/* Redirect Constants */
export const REDIRECT = {
    SET_URL: "REDIRECT:SET_URL",
};
